<template>
    <div v-if="trailerAsset" class="trailer-details-widget">
        <h1 class="trailer-details-widget__title">
            <img
                v-if="trailerAsset.asset_type_marker_ax_road"
                class="trailer-details-widget__icon"
                :src="trailerAsset.asset_type_marker_ax_road"
                width="24"
                height="24"
            />
            <TrailerIcon v-else />
            {{ assetType.name }}
        </h1>
        <div class="l-inline l-gap-2">
            <InfoBlock
                :label="$t('trailerNumber')"
                :value="trailerAsset.identification"
                class="l-half-width"
            />
        </div>
        <div v-if="trailerAsset.trailer" class="l-inline l-gap-2">
            <InfoBlock
                :label="$t('payload')"
                :value="formatWeight(trailerAsset.trailer.payload)"
                class="l-half-width"
            />
            <InfoBlock
                :label="$t('totalWeight')"
                :value="formatWeight(trailerAsset.trailer.weight)"
                class="l-half-width"
            />
        </div>
        <!-- <div>
            <AxRoadButton :to="to" size="small" variant="solid">
                {{ $t('details') }}
            </AxRoadButton>
        </div> -->
    </div>
</template>
<script>
import TrailerIcon from '@/components/icons/TrailerIcon.vue'
import InfoBlock from '@/components/ax-road/InfoBlock.vue'
// import AxRoadButton from '@/components/ax-road/AxRoadButton.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'TrailerDetailsWidget',
    components: {
        TrailerIcon,
        InfoBlock,
        // AxRoadButton,
    },
    props: {
        trailerAsset: {
            type: Object,
            default: null,
        },
        to: {
            type: [String, Object],
            default: '',
            required: false,
        },
    },
    computed: {
        ...mapGetters('tracker', ['assetTypesById']),
        assetType() {
            return (
                this.assetTypesById[this.trailerAsset.asset_type] ||
                this.$t('trailer')
            )
        },
    },
    methods: {
        formatWeight(weight) {
            return weight
                ? `${weight / 1000} ${this.$t('shared.units.tons')}`
                : '-'
        },
    },
}
</script>

<i18n>
{
    "en" : {
        "payload": "Payload",
        "totalWeight": "Total weight",
        "trailer": "Trailer",
        "trailerNumber": "Trailer number",
        "details": "Details"
    },
    "de" : {
        "payload": "Nutzlast",
        "totalWeight": "Gesamtgewicht",
        "trailer": "Anhänger",
        "trailerNumber": "Anhängernummer",
        "details": "Details"
    },
    "fr" : {
        "payload": "Charge utile",
        "totalWeight": "Poids total",
        "trailer": "Remorque",
        "trailerNumber": "Numéro de remorque",
        "details": "Détails"
    },
    "it": {
        "payload": "Carico utile",
        "totalWeight": "Peso totale",
        "trailer": "Rimorchio",
        "trailerNumber": "Numero del rimorchio",
        "details": "Dettagli"
    }
}
</i18n>

<style lang="scss">
.trailer-details-widget {
    padding: 0 24px 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    border-bottom: $style-border;

    &__icon {
        filter: invert(1) brightness(0);
    }

    &__title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 15px;
        font-weight: 700;
        line-height: 20px;
    }
}
</style>
